import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

dayjs.extend(isoWeek)

export const displayDate = (group: string) => {
	const now = dayjs()

	switch (group) {
		case 'today':
			return now.format('DD.MM.YYYY')
		case 'yesterday':
			return now.subtract(1, 'day').format('DD.MM.YYYY')
		case 'thisWeek':
			return `${now.startOf('isoWeek').format('DD.MM')} - ${now
				.endOf('isoWeek')
				.format('DD.MM.YYYY')}`
		case 'lastWeek':
			return `${now.subtract(1, 'week').startOf('isoWeek').format('DD.MM')} - ${now
				.subtract(1, 'week')
				.endOf('isoWeek')
				.format('DD.MM.YYYY')}`
		case 'lastMonth':
			return `${now.subtract(1, 'month').startOf('month').format('DD.MM')} - ${now
				.subtract(1, 'month')
				.endOf('month')
				.format('DD.MM.YYYY')}`
		default:
			return ''
	}
}
